export default {
  buttons: {
    start: 'Aloita ajoitetun tilauksen valmistelu',
  },
};
